import { render, staticRenderFns } from "./Block1.vue?vue&type=template&id=f6fbbcc6&scoped=true&"
import script from "./Block1.vue?vue&type=script&lang=js&"
export * from "./Block1.vue?vue&type=script&lang=js&"
import style0 from "./Block1.vue?vue&type=style&index=0&id=f6fbbcc6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6fbbcc6",
  null
  
)

export default component.exports